<div class="mi-unauthorized-page d-flex flex-column align-items-center">
    <div>
        <img src="assets/images/general/error/unauthorized.svg" alt="unauthorized page">
    </div>
    <div>
        <p class="fw-bold">{{errorText?.unauthorizedPage?.text}}</p>
    </div>

</div>